export function GetCurrenyFun(){
    let value = localStorage.getItem("currency")
    console.log("temp",value);
    return value||""
    
}